

import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { CommonService } from '../../_services/common.service';
import { ToastrService } from 'ngx-toastr';
import { FaqService } from '../../features/faq/faq.service';
import { ActivatedRoute } from '@angular/router';
import { ValidationService } from '../../_services/validation.service';
import { Directive, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
@Component({
  selector: 'app-manage',
  templateUrl: './faq.component.html',
  styleUrls: [ './faq.component.scss' ]
})
export class FaqComponent implements OnInit {
  
  @Output() response: EventEmitter<boolean> = new EventEmitter();
  faqForm!: FormGroup;
  submitted!: boolean;
  faqID: any;
  option: any = {};

  constructor(
    public fb: FormBuilder,
    public commonService: CommonService,
    public toastServcie: ToastrService,
    public faqService: FaqService,
    public route: ActivatedRoute,
      public dialogRef: MatDialogRef<FaqComponent>,
  @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.initForm(this.option);
  }

  ngOnInit() {
    this.response = new EventEmitter();
    this.faqService.getFaqDetail(this.faqID).subscribe({

     next: (res: any) => {
        if (res && res.success) {
          this.initForm(res.data);
        }
      },
    error:  (error: any) => {
        this.commonService.showError('', error.error.message);
      }
  });
  }

  initForm(option:any) {
    this.faqForm = this.fb.group({
      question: new FormControl(
        option.question ? option.question : '',
        Validators.compose([ ValidationService.required ])
      ),
      answer: new FormControl(
        option.answer ? option.answer : '',
        Validators.compose([ ValidationService.required ])
      ),
      active: new FormControl(option.active ? option.active : false),
      seq_no: new FormControl(
        option.seq_no ? option.seq_no : null,
        Validators.compose([ ValidationService.required ])
      )
    });
  }

  save(faqForm: FormGroup) {
    this.submitted = true;
    if (this.faqForm.invalid) {
      return ;
    }

    if (!this.faqID) {
      const categoryData = faqForm.value;
      this.faqService.createFAQ(categoryData).subscribe({
       next: (res: any) => {
          if (res && res.success) {
            this.response.emit(res);
          } else {
            this.commonService.showError('', res.message);
          }
        },
     error:   (err: any) => {
          this.commonService.showError('', err.error.message);
        }
     } );
    } else {
      this.faqService.updateFAQ(this.faqID, faqForm.value).subscribe({
    next: (res: any) => {
          if (res && res.success) {
            this.response.emit(res);
          } else {
            this.commonService.showError('', res.message);
          }
        },
       error: (err:any) => {
          this.commonService.showError('', err.message);
        }
    });
    }
  }

  close() {
    // this.response.emit();
    this.dialogRef.close({ success: true }); // or false or with message

  }
}
